//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ChangeColor",1,0],[0,"ChangeTranslucency",1,0],[0,"ChangeVisibility",1,0],[1,"CollisionSensor",0,"SelectNXObject",0],[0,"Color",1,0],[0,"ExecuteMode",1,0],[0,"InitVisibility",1,0],[0,"Name",1,0],[1,"ObjectList",0,"SelectNXObjectList",0],[0,"Translucency",1,0]],[[["objectTags"],"SetObjectList",{},1,0]],[]];
SPLM.Mechatronics.DisplayChangerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.DisplayChangerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.DisplayChangerBuilder.ExecuteModes = Object.freeze({
    "None" : "None", "Always" : "Always", "OnceOnly" : "OnceOnly"});

export default SPLM;